<template>
	<v-container>
		<v-btn class="ml-5" color="primary" @click="fixImportGridFields">
			Fix ImportGridFields
		</v-btn>
	</v-container>
</template>

<script>
import httpClient from '../services/httpClientService';
import { GeneralActions } from '../store/actions';
export default {
	name: 'DevFixes',
	methods: {
		fixImportGridFields() {
			this.$store.dispatch(GeneralActions.LOADING, true);
			httpClient
				.Get(
					'/ProjectGridsModule/FixImportGridViewFieldsForExistingTemplates'
				)
				.then(() => {
					alert('success');
				})
				.catch((error) => {
					console.log(error);
					alert('error');
				})
				.finally(() => {
					this.$store.dispatch(GeneralActions.LOADING, false);
				});
		},
	},
};
</script>
